import Backbone from 'backbone';

var DeviceInviteRequest = Backbone.Model.extend({
    emulateHTTP: false,

    idAttribute: 'deviceInviteId',

    backend: 'gcapi',

    url: function() {
        let url = '/invite-service/invite';

        if (this.deviceInviteId) {
            url += '/' + this.deviceInviteId;
        }
        return url;
    },

    initialize: function(args) {
        this.deviceInviteId = args.deviceInviteId;
        this.deviceId = args.deviceId;
        this.inviteDeviceDTO = args.inviteDeviceDTO;
    },

    sync: function(method, model, options) {
        if (this.inviteDeviceDTO) {
            options.url = this.url();
            options.type = 'POST';
            options.data = JSON.stringify(this.inviteDeviceDTO);
            options.contentType = 'application/json';
        }

        if (this.get('inviteeEmail') === null) {
            this.unset('inviteeEmail');
        }
        if (this.get('productPartNumber') && !this.inviteDeviceDTO) {
            this.unset('productPartNumber');
        }

        Backbone.sync.call(this, method, model, options);
    }
});

export default DeviceInviteRequest;
